/**
 * Layout principal del dashboard
 * Incluye Sidebar y área de contenido
 * Maneja responsive (sidebar fijo en desktop, drawer en mobile)
 */

import { useState, useEffect, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/shared/components/Sidebar/Sidebar';
import { LoadingSpinner } from '@/shared';
import { FiMenu, FiX } from 'react-icons/fi';
import styles from './DashboardLayout.module.css';

export function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // En desktop, siempre mostrar sidebar
      if (!mobile) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    // Inicializar estado según tamaño inicial
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={styles.layout}>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      
      {/* Header mobile con botón hamburguesa */}
      {isMobile && (
        <header className={styles.mobileHeader}>
          <button
            className={styles.menuButton}
            onClick={toggleSidebar}
            aria-label="Abrir menú"
            aria-expanded={isSidebarOpen}
          >
            {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
          <div className={styles.mobileHeaderTitle}>
            <h1 className={styles.mobileTitle}>JaviCore</h1>
            <p className={styles.mobileSubtitle}>Panel de Control</p>
          </div>
        </header>
      )}

      {/* Contenido principal */}
      <main className={styles.main}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}

